"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable quotes, quote-props, comma-dangle */

/**
 * This file is regenerated by generate-api-constants.js
 * Do not edit it manually.
 * Last generated Mon Dec 03 2018 09:43:56 GMT-0500 (EST)
 **/

var COUNTRY_CODE_TO_NAME = exports.COUNTRY_CODE_TO_NAME = {
  "USA": "United States",
  "CAN": "Canada",
  "GBR": "United Kingdom",
  "AUS": "Australia",
  "SGP": "Singapore",
  "HKG": "Hong Kong",
  "ARE": "United Arab Emirates",
  "ZAF": "South Africa",
  "NZL": "New Zealand",
  "NLD": "Netherlands",
  "IRL": "Ireland",
  "NOR": "Norway",
  "SWE": "Sweden",
  "THA": "Thailand",
  "DEU": "Germany",
  "MYS": "Malaysia"
};

var COUNTRY_CODE_TO_SHORT_CODE = exports.COUNTRY_CODE_TO_SHORT_CODE = {
  "USA": "US",
  "CAN": "CA",
  "GBR": "GB",
  "AUS": "AU",
  "SGP": "SG",
  "HKG": "HK",
  "ARE": "AE",
  "ZAF": "ZA",
  "NZL": "NZ",
  "NLD": "NL",
  "IRL": "IE",
  "NOR": "NO",
  "SWE": "SE",
  "THA": "TH",
  "DEU": "DE",
  "MYS": "MY"
};